import { ClickEvent, DataDisplayEvent, DataSourceAction, DataSourceExecutionEvent, Label, LookupModelSelectionEvent, TableRowBeforeSaveEvent } from "@mcleod/components";
import { AutogenLayoutLateRouteView } from "./autogen/AutogenLayoutLateRouteView";
import { ModelRow, StringUtil } from "@mcleod/core";
import { OrderTabView } from "../OrderTabView";

export class LateRouteView extends AutogenLayoutLateRouteView {

    onLoad() {
        this.labelOrderNumber.addUnderlineWhenMouseOver();
        this.labelMovementNumber.addUnderlineWhenMouseOver();
        this.layoutTableComment.tableComments.addRowBeforeSaveListener((event: TableRowBeforeSaveEvent) => {
            const commentRow = event.getTableRow().data as ModelRow;
            commentRow.set("parent_row_id", this.activeRow.get("next_stop.id"));
        });
        this.layoutTableComment.displayCopyOrderFields = false;
    }

    sourceLateRouteViewAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            this.textboxDepartDate.caption = `${this.activeRow.getBoolean("actual_depart") ? "Actual" : "Scheduled"} Departure`;
            if (!this.activeRow.isNull("late_route_status_color")) {
                this.updateLateRouteStatusColor(this.activeRow.get("late_route_status_color", ""));
            }
        }
    }

    labelOrderNumberOnClick(event: ClickEvent) {
        const orderId = (event.target as Label).text;
        if (!StringUtil.isEmptyString(orderId) && orderId != "--") {
            OrderTabView.navigateTo({key: orderId, newTab: true});
        }
    }

    labelMovementNumberOnClick(event: ClickEvent) {
        const movementId = (event.target as Label).text;
        if (!StringUtil.isEmptyString(movementId) && movementId != "--") {
            OrderTabView.navigateTo({key: movementId, orderId: this.labelOrderNumber.text, newTab: true});
        }
    }

    diffOnDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        if (event.rowData) {
            if (event.rowData.isNull(label.field))
                return;
            let field: string;
            if (label.field.includes("projected")) {
                field = "projected_color";
            } else if (label.field.includes("planned")) {
                field = "planned_color";
            } else {
                field = "nonstop_color"
            }
            label.color = this.activeRow.get(field);
            label.text = label.text + ` ${label.color == "default" ? "On Time" : label.color == "error" ? "Late" : "Early"}`;
        }
    }

    textboxLateRouteStatusOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selected = event.selection;
        this.updateLateRouteStatusColor(selected?.get("late_route_status_color", null) ?? null);
    }

    updateLateRouteStatusColor(color: string) {
        this.textboxLateRouteStatus._inputDiv.style.backgroundColor = color ?? "transparent";
        this.textboxLateRouteStatus.color = color != null ? "default.reverse" : "default";
    }

}
